/* ALCAMI BRAND: small site-wide behaviour, loaded on every page from layout/theme.liquid
   (next to assets/alcami-brand.css). Project doc: claude/alcami-brand-language.md.

   Product gallery thumbnails: custom.js shows 3 thumbnails per row on phones, which made the
   buy box very tall. Here the thumbnail slider switches to 5 per row on phones (4 on wider
   screens, unchanged). The slider keeps its link to the main gallery.

   20 Oct 2026 (speed): this file runs before custom.js builds the sliders (both scripts are
   deferred and custom.js builds them on DOMContentLoaded), so the 5-per-row setting is now
   handed to slick up front through a data-slick attribute, which slick reads over the options
   in custom.js. The row is built once at its final size instead of being built at 3 and then
   rebuilt at 5, which moved the page. The old after-the-fact switch stays as a fallback. */
(function () {
  if (window.__alcBrand) return;
  window.__alcBrand = true;

  var PHONE_THUMBS = 5;
  var RESPONSIVE = [{ breakpoint: 767, settings: { slidesToShow: PHONE_THUMBS } }];

  /* before slick starts: let slick read the phone count from the markup */
  var preset = function () {
    var els = document.querySelectorAll('.thumbnail-gallery:not(.slick-initialized)');
    for (var i = 0; i < els.length; i++) {
      if (els[i].hasAttribute('data-slick')) continue;
      els[i].setAttribute('data-slick', JSON.stringify({ responsive: RESPONSIVE }));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preset);
  preset();

  /* fallback: a slider built without the preset still ends up at 5 per row on phones */
  var thumbs = function () {
    if (!document.querySelector('.thumbnail-gallery')) return true;      /* nothing to do on this page */
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return false;
    var $ = window.jQuery, $t = $('.thumbnail-gallery.slick-initialized');
    if (!$t.length) return false;                                         /* custom.js has not built it yet */
    $t.each(function () {
      if (!this.slick || this.__alcThumbs) return;
      this.__alcThumbs = true;
      var r = this.slick.options && this.slick.options.responsive;
      if (r && r.length === 1 && r[0].breakpoint === 767 && r[0].settings && r[0].settings.slidesToShow === PHONE_THUMBS) return;
      $(this).slick('slickSetOption', 'responsive', RESPONSIVE, true);
    });
    return true;
  };

  var tries = 0;
  var run = function () {
    if (thumbs() || ++tries > 40) return;
    setTimeout(run, 150);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* CRO report M2 (2 Nov 2026, Carlos): taps that did nothing now do something. Clarity showed shoppers tapping
   these about 900 times a month with no response. Styles are added by this script, so no stylesheet changes.
   1. Buy box gallery (homepage, and the Smart Latte, Double and Triple pages): a tap on an image opens it full
      screen. Swipe or the arrows move through the images the gallery shows (after the flavour filter). A tap on
      the open image zooms it in (drag to look around, tap again to zoom out). The close button, Escape or the
      phone's back button closes it. Slick swallows the click that ends a swipe, so swiping the gallery doesn't
      open it. Clarity events: gallery_zoom_open, gallery_zoom_in.
   2. "Frequently bought together" card (Himalayan Shilajit): a tap anywhere on the card does what its + does
      (adds it and opens the cart). A second card tap within 3 s is ignored. Clarity event: fbt_card_add.
   3. Homepage hero: the "Trusted by 20,000+ customers" line scrolls to the reviews wall. Clarity event:
      hero_trust_reviews. */
(function () {
  if (window.__alcTaps) return;
  window.__alcTaps = true;

  var GALLERY = '.elements-triple-v2-home .main-gallery';
  function track(name) { try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (err) {} }

  var CSS = [
    GALLERY + ' .slick-slide img{cursor:zoom-in;}',
    '.bought-list li{cursor:pointer;}',
    '.ahv-rating[data-alc-trust]{cursor:pointer;}',
    '.ahv-rating[data-alc-trust] span:not(.ahv-stars){text-decoration:underline;text-underline-offset:3px;text-decoration-thickness:1px;}',
    'html.alc-zoom-lock,html.alc-zoom-lock body{overflow:hidden !important;}',
    '#alc-zoom{position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483000;display:none;flex-direction:column;background:#fff;color:#23170F;}',
    '#alc-zoom.is-open{display:flex;}',
    '.alc-zoom__bar{flex:0 0 56px;display:flex;align-items:center;justify-content:space-between;padding:0 6px 0 18px;font:500 14px/1 Inter,system-ui,sans-serif;}',
    '.alc-zoom__x{width:44px;height:44px;display:flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:none;color:inherit;cursor:pointer;padding:0;}',
    '.alc-zoom__x svg{width:22px;height:22px;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;}',
    '.alc-zoom__track{position:relative;flex:1 1 auto;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;overscroll-behavior:contain;scrollbar-width:none;}',
    '.alc-zoom__track::-webkit-scrollbar{display:none;}',
    '.alc-zoom__track.is-locked{overflow:hidden;}',
    '.alc-zoom__slide{flex:0 0 100%;width:100%;height:100%;scroll-snap-align:center;scroll-snap-stop:always;display:flex;align-items:center;justify-content:center;overflow:hidden;}',
    '.alc-zoom__slide img{display:block;max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;cursor:zoom-in;-webkit-user-select:none;user-select:none;-webkit-user-drag:none;}',
    '.alc-zoom__slide.is-zoomed{display:block;overflow:auto;}',
    '.alc-zoom__slide.is-zoomed img{max-width:none;max-height:none;width:220%;cursor:zoom-out;}',
    '.alc-zoom__nav{position:absolute;top:50%;margin-top:-22px;width:44px;height:44px;display:none;align-items:center;justify-content:center;border:1px solid rgba(35,23,15,.18);border-radius:50%;background:#fff;color:#23170F;cursor:pointer;padding:0;z-index:1;}',
    '.alc-zoom__nav svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;}',
    '.alc-zoom__prev{left:16px;}.alc-zoom__next{right:16px;}',
    '@media (min-width:768px){.alc-zoom__nav{display:flex;}}'
  ].join('');
  function addCss() {
    if (document.getElementById('alc-taps-css')) return;
    var s = document.createElement('style');
    s.id = 'alc-taps-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }
  addCss();

  /* ---------- 1. gallery full screen ---------- */
  var box = null, track_ = null, count = null, pushed = false, list = [];
  function bigSrc(img) {
    var best = '', bw = 0, set = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
    set.split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/), w = parseInt(bits[1], 10) || 0;
      if (bits[0] && w >= bw) { bw = w; best = bits[0]; }
    });
    var u = best || img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    if (/[?&]width=\d+/.test(u)) u = u.replace(/([?&])width=\d+/, '$1width=1800');
    else if (u.indexOf('/cdn/shop/') > -1) u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=1800';
    return u;
  }
  function fileOf(u) { u = (u || '').split('?')[0]; return u.substring(u.lastIndexOf('/') + 1); }
  function gallerySlides(gal) {
    var out = [], nodes = null;
    try {
      var $ = window.jQuery;
      if ($ && $(gal).hasClass('slick-initialized')) nodes = $(gal).slick('getSlick').$slides.toArray();
    } catch (err) { nodes = null; }
    if (!nodes) nodes = Array.prototype.slice.call(gal.querySelectorAll('.slick-slide:not(.slick-cloned)'));
    nodes.forEach(function (n) {
      var img = n.querySelector('img');
      if (img) out.push({ src: bigSrc(img), alt: img.getAttribute('alt') || '', file: fileOf(img.getAttribute('src') || bigSrc(img)) });
    });
    return out;
  }
  function svg(d) { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + d + '"/></svg>'; }
  function build() {
    if (box) return;
    box = document.createElement('div');
    box.id = 'alc-zoom';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product images');
    box.innerHTML = '<div class="alc-zoom__bar"><span class="alc-zoom__count" aria-live="polite"></span>' +
      '<button type="button" class="alc-zoom__x" aria-label="Close">' + svg('M6 6l12 12M18 6L6 18') + '</button></div>' +
      '<div class="alc-zoom__track"></div>' +
      '<button type="button" class="alc-zoom__nav alc-zoom__prev" aria-label="Previous image">' + svg('M15 5l-7 7 7 7') + '</button>' +
      '<button type="button" class="alc-zoom__nav alc-zoom__next" aria-label="Next image">' + svg('M9 5l7 7-7 7') + '</button>';
    document.body.appendChild(box);
    track_ = box.querySelector('.alc-zoom__track');
    count = box.querySelector('.alc-zoom__count');
    box.querySelector('.alc-zoom__x').addEventListener('click', function () { close(true); });
    box.querySelector('.alc-zoom__prev').addEventListener('click', function () { go(index() - 1); });
    box.querySelector('.alc-zoom__next').addEventListener('click', function () { go(index() + 1); });
    track_.addEventListener('scroll', function () { label(); }, { passive: true });
    track_.addEventListener('click', function (e) {
      var img = e.target && e.target.closest ? e.target.closest('.alc-zoom__slide img') : null;
      if (!img) return;
      var slide = img.parentNode, zoomed = slide.classList.contains('is-zoomed');
      if (zoomed) {
        slide.classList.remove('is-zoomed');
        track_.classList.remove('is-locked');
        return;
      }
      var r = img.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
      slide.classList.add('is-zoomed');
      track_.classList.add('is-locked');
      slide.scrollLeft = fx * img.offsetWidth - slide.clientWidth / 2;
      slide.scrollTop = fy * img.offsetHeight - slide.clientHeight / 2;
      track('gallery_zoom_in');
    });
  }
  function index() { return track_ && track_.clientWidth ? Math.round(track_.scrollLeft / track_.clientWidth) : 0; }
  function label() { if (count) count.textContent = (Math.min(index(), list.length - 1) + 1) + ' / ' + list.length; }
  function unzoom() {
    var z = track_ ? track_.querySelectorAll('.is-zoomed') : [];
    for (var i = 0; i < z.length; i++) z[i].classList.remove('is-zoomed');
    if (track_) track_.classList.remove('is-locked');
  }
  function go(i) {
    if (!track_ || !list.length) return;
    unzoom();
    i = (i + list.length) % list.length;
    var left = i * track_.clientWidth;
    try { track_.scrollTo({ left: left, behavior: 'smooth' }); } catch (err) { track_.scrollLeft = left; }
    /* where smooth scrolling doesn't run (some in-app browsers), jump instead */
    setTimeout(function () { if (Math.abs(track_.scrollLeft - left) > 2) { track_.scrollLeft = left; label(); } }, 450);
  }
  function open(gal, img) {
    list = gallerySlides(gal);
    if (!list.length) return;
    build();
    var file = fileOf(img.getAttribute('src') || bigSrc(img)), start = 0;
    for (var i = 0; i < list.length; i++) { if (list[i].file === file) { start = i; break; } }
    track_.innerHTML = list.map(function (s, n) {
      return '<div class="alc-zoom__slide"><img src="' + s.src.replace(/"/g, '&quot;') + '" alt="' + s.alt.replace(/"/g, '&quot;') + '"' +
        (Math.abs(n - start) > 1 ? ' loading="lazy"' : '') + ' draggable="false"></div>';
    }).join('');
    box.classList.add('is-open');
    document.documentElement.classList.add('alc-zoom-lock');
    track_.scrollLeft = start * track_.clientWidth;
    label();
    try { history.pushState({ alcZoom: true }, ''); pushed = true; } catch (err) { pushed = false; }
    var x = box.querySelector('.alc-zoom__x');
    try { x.focus({ preventScroll: true }); } catch (err) { x.focus(); }
    track('gallery_zoom_open');
  }
  function close(fromButton) {
    if (!box || !box.classList.contains('is-open')) return;
    if (fromButton && pushed) { pushed = false; history.back(); return; }   /* popstate below closes it */
    pushed = false;
    unzoom();
    box.classList.remove('is-open');
    document.documentElement.classList.remove('alc-zoom-lock');
    track_.innerHTML = '';
  }
  window.addEventListener('popstate', function () { if (box && box.classList.contains('is-open')) { pushed = false; close(false); } });
  document.addEventListener('keydown', function (e) {
    if (!box || !box.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(true); }
    else if (e.key === 'ArrowRight') go(index() + 1);
    else if (e.key === 'ArrowLeft') go(index() - 1);
  }, true);

  /* ---------- clicks: gallery image, bought-together card ---------- */
  var lastFbt = 0;
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var img = t.closest(GALLERY + ' .slick-slide img');
    if (img) {
      if (img.closest('a,button')) return;
      e.preventDefault();
      open(img.closest('.main-gallery'), img);
      return;
    }
    var li = t.closest('.bought-list li');
    if (li && !t.closest('a.bought-product-add')) {
      var add = li.querySelector('a.bought-product-add');
      if (!add) return;
      e.preventDefault();
      var now = Date.now();
      if (now - lastFbt < 3000) return;
      lastFbt = now;
      track('fbt_card_add');
      add.click();
    }
  });

  /* ---------- 3. hero trust line -> reviews wall ---------- */
  function trust() {
    var row = document.querySelector('[id*="__alcami_hero_video"] .ahv-rating');
    var wall = document.querySelector('[id*="__alcami_reviews_wall"]');
    if (!row || !wall || row.hasAttribute('data-alc-trust')) return;
    row.setAttribute('data-alc-trust', '');
    row.setAttribute('role', 'link');
    row.setAttribute('tabindex', '0');
    row.setAttribute('aria-label', (row.textContent || '').trim() + ': see the reviews');
    var goWall = function (e) {
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      track('hero_trust_reviews');
      /* land the section's top just under the header when the header is pinned */
      var off = 0, h = document.querySelector('.shopify-section-header-sticky, .store-header');
      if (h) { var p = getComputedStyle(h).position; if (p === 'sticky' || p === 'fixed') off = h.offsetHeight; }
      var y = wall.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - off - 8;
      try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, y); }
    };
    row.addEventListener('click', goWall);
    row.addEventListener('keydown', goWall);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', trust);
  else trust();
})();
